function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "box",
  transform: "translate(0.127 0.04)"
}, React.createElement("g", {
  id: "Group_1603",
  "data-name": "Group 1603",
  transform: "translate(6.966 6.681)"
}, React.createElement("g", {
  id: "Group_1602",
  "data-name": "Group 1602"
}, React.createElement("path", {
  id: "Path_1226",
  "data-name": "Path 1226",
  d: "M160.054,146.384a.279.279,0,0,0-.014-.033.387.387,0,0,0-.022-.054.37.37,0,0,0-.025-.034.35.35,0,0,0-.032-.041l-.034-.027a.416.416,0,0,0-.037-.03l-3.667-2.2a.367.367,0,0,0-.378,0l-3.667,2.2a.323.323,0,0,0-.038.03l-.034.027a.386.386,0,0,0-.032.041.328.328,0,0,0-.026.034.387.387,0,0,0-.022.052.368.368,0,0,0-.014.035.354.354,0,0,0-.013.095v3.667a.367.367,0,0,0,.178.314l3.667,2.2,0,0,0,0a.357.357,0,0,0,.06.025l.025.01a.361.361,0,0,0,.191,0l.025-.01a.356.356,0,0,0,.06-.025l0,0,0,0,3.667-2.2a.367.367,0,0,0,.178-.314v-3.667A.358.358,0,0,0,160.054,146.384Zm-4.02-1.677,1.121.672-2.954,1.772-1.121-.672Zm-.367,6.991-2.933-1.76v-2.811l2.933,1.76Zm.367-3.446-1.121-.672,2.954-1.772,1.121.672Zm3.3,1.687L156.4,151.7v-2.812l2.933-1.76Z",
  transform: "translate(-152 -143.913)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1605",
  "data-name": "Group 1605",
  transform: "translate(9.606 0.089)"
}, React.createElement("g", {
  id: "Group_1604",
  "data-name": "Group 1604",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_1227",
  "data-name": "Path 1227",
  d: "M211.287.227a.38.38,0,0,0-.587,0l-1.1,1.467.587.44.44-.587V4.481h.733V1.547l.44.587.587-.44Z",
  transform: "translate(-209.6 -0.089)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1607",
  "data-name": "Group 1607",
  transform: "translate(9.606 17.681)"
}, React.createElement("g", {
  id: "Group_1606",
  "data-name": "Group 1606"
}, React.createElement("path", {
  id: "Path_1228",
  "data-name": "Path 1228",
  d: "M211.8,386.258l-.44.587v-2.933h-.733v2.933l-.44-.587-.587.44,1.1,1.467a.367.367,0,0,0,.587,0l1.1-1.467Z",
  transform: "translate(-209.6 -383.911)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1609",
  "data-name": "Group 1609",
  transform: "translate(10.633 5.214)"
}, React.createElement("g", {
  id: "Group_1608",
  "data-name": "Group 1608"
}, React.createElement("rect", {
  id: "Rectangle_774",
  "data-name": "Rectangle 774",
  width: 0.733,
  height: 0.733,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1611",
  "data-name": "Group 1611",
  transform: "translate(10.633 16.214)"
}, React.createElement("g", {
  id: "Group_1610",
  "data-name": "Group 1610"
}, React.createElement("rect", {
  id: "Rectangle_775",
  "data-name": "Rectangle 775",
  width: 0.733,
  height: 0.733,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1613",
  "data-name": "Group 1613",
  transform: "translate(-0.001 9.687)"
}, React.createElement("g", {
  id: "Group_1612",
  "data-name": "Group 1612",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_1229",
  "data-name": "Path 1229",
  d: "M4.4,210.538H1.466l.587-.44-.44-.587-1.467,1.1a.367.367,0,0,0,0,.587l1.467,1.1.44-.587-.587-.44H4.4Z",
  transform: "translate(0.001 -209.511)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1615",
  "data-name": "Group 1615",
  transform: "translate(17.599 9.687)"
}, React.createElement("g", {
  id: "Group_1614",
  "data-name": "Group 1614"
}, React.createElement("path", {
  id: "Path_1230",
  "data-name": "Path 1230",
  d: "M388.327,210.684a.368.368,0,0,0-.073-.073l-1.467-1.1-.44.587.587.44H384v.733h2.933l-.587.44.44.587,1.467-1.1A.367.367,0,0,0,388.327,210.684Z",
  transform: "translate(-384 -209.511)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1617",
  "data-name": "Group 1617",
  transform: "translate(5.133 10.714)"
}, React.createElement("g", {
  id: "Group_1616",
  "data-name": "Group 1616"
}, React.createElement("rect", {
  id: "Rectangle_776",
  "data-name": "Rectangle 776",
  width: 0.733,
  height: 0.733,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1619",
  "data-name": "Group 1619",
  transform: "translate(16.133 10.714)"
}, React.createElement("g", {
  id: "Group_1618",
  "data-name": "Group 1618"
}, React.createElement("rect", {
  id: "Rectangle_777",
  "data-name": "Rectangle 777",
  width: 0.733,
  height: 0.733,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1621",
  "data-name": "Group 1621",
  transform: "translate(3.112 3.193)"
}, React.createElement("g", {
  id: "Group_1620",
  "data-name": "Group 1620"
}, React.createElement("path", {
  id: "Path_1231",
  "data-name": "Path 1231",
  d: "M71.393,70.784,69.319,68.71l.726.1.1-.726-1.815-.261a.367.367,0,0,0-.417.417l.259,1.815.726-.1-.1-.726L70.873,71.3Z",
  transform: "translate(-67.913 -67.823)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1623",
  "data-name": "Group 1623",
  transform: "translate(15.407 15.489)"
}, React.createElement("g", {
  id: "Group_1622",
  "data-name": "Group 1622"
}, React.createElement("path", {
  id: "Path_1232",
  "data-name": "Path 1232",
  d: "M339.643,339.153l-.259-1.815-.727.1.1.726-2.074-2.074-.518.518,2.074,2.074-.725-.1-.1.726,1.815.259a.362.362,0,0,0,.052,0,.367.367,0,0,0,.367-.367A.359.359,0,0,0,339.643,339.153Z",
  transform: "translate(-336.168 -336.095)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1625",
  "data-name": "Group 1625",
  transform: "translate(6.592 6.673)"
}, React.createElement("g", {
  id: "Group_1624",
  "data-name": "Group 1624"
}, React.createElement("rect", {
  id: "Rectangle_778",
  "data-name": "Rectangle 778",
  width: 0.733,
  height: 0.733,
  transform: "translate(0 0.519) rotate(-45)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1627",
  "data-name": "Group 1627",
  transform: "translate(14.37 14.451)"
}, React.createElement("g", {
  id: "Group_1626",
  "data-name": "Group 1626"
}, React.createElement("rect", {
  id: "Rectangle_779",
  "data-name": "Rectangle 779",
  width: 0.733,
  height: 0.733,
  transform: "translate(0 0.519) rotate(-45)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1629",
  "data-name": "Group 1629",
  transform: "translate(3.112 15.488)"
}, React.createElement("g", {
  id: "Group_1628",
  "data-name": "Group 1628"
}, React.createElement("path", {
  id: "Path_1233",
  "data-name": "Path 1233",
  d: "M69.322,338.671,71.4,336.6l-.517-.518-2.074,2.074.1-.726-.726-.1-.261,1.815a.367.367,0,0,0,.363.419.362.362,0,0,0,.052,0l1.815-.259-.1-.726Z",
  transform: "translate(-67.918 -336.079)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1631",
  "data-name": "Group 1631",
  transform: "translate(15.407 3.195)"
}, React.createElement("g", {
  id: "Group_1630",
  "data-name": "Group 1630"
}, React.createElement("path", {
  id: "Path_1234",
  "data-name": "Path 1234",
  d: "M339.538,67.965a.363.363,0,0,0-.311-.1l-1.815.259.1.726.726-.1-2.074,2.074.518.518,2.074-2.074-.1.725.726.1.259-1.815A.367.367,0,0,0,339.538,67.965Z",
  transform: "translate(-336.168 -67.857)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1633",
  "data-name": "Group 1633",
  transform: "translate(6.592 14.451)"
}, React.createElement("g", {
  id: "Group_1632",
  "data-name": "Group 1632"
}, React.createElement("rect", {
  id: "Rectangle_780",
  "data-name": "Rectangle 780",
  width: 0.733,
  height: 0.733,
  transform: "translate(0 0.519) rotate(-45)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), React.createElement("g", {
  id: "Group_1635",
  "data-name": "Group 1635",
  transform: "translate(14.37 6.672)"
}, React.createElement("g", {
  id: "Group_1634",
  "data-name": "Group 1634"
}, React.createElement("rect", {
  id: "Rectangle_781",
  "data-name": "Rectangle 781",
  width: 0.733,
  height: 0.733,
  transform: "translate(0 0.519) rotate(-45)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))));

var SvgSetting = function SvgSetting(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22.228,
    height: 22.247,
    viewBox: "0 0 22.228 22.247",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSetting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/setting.705d3a37.svg";
export { ForwardRef as ReactComponent };